// Copyright (c) 2021 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import {FormattedMessage} from 'react-intl';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import LaborRateMain from './labor-rate-main';
import {Link} from 'react-router';
import SubmitButton from './submit-button';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {canEnableSubmit} from '../services/labor-rate-change-services';

function handleDealershipModalClose() {

    this.actions.updateDealershipModalVisibility(false);

}
function onSubmit() {

    this.actions.postMassLaborRateChange(this.massLaborRate);

}

function handleDealershipModalOpen() {

    this.actions.updateDealershipModalVisibility(true);

}

class MassLaborRateChange extends Component {

    componentWillMount() {

        if (this.props.queryParams.requestId) {

            this.props.actions.readReturnedDealersLaborRates(this.props.queryParams.requestId);

        } else if (this.props.selectedDealers.length > 0) {

            this.props.actions.readSelectedLaborRates(this.props.selectedDealers);

        } else {

            document.location.href = '#/claims/labor-rates';

        }

    }

    componentWillUnmount() {

        this.props.actions.resetDealerDetails();

    }

    render() {

        return (
            <section className='labor-rate-change'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <h2 className='title-row'>
                    { this.props.queryParams.requestId ?
                        <h2 className='dealer-name'>{this.props.queryParams.requestId}</h2> :
                        <section className='dealer-name'>
                            <FormattedMessage id='NEW_REQUEST_ENTER_RATES'/>
                        </section>
                    }
                    <section className='buttons'>
                        <Link
                            className='button-secondary'
                            to='/claims/labor-rates'
                        >
                            <FormattedMessage id='CANCEL'/>
                        </Link>
                        {
                        this.props.massLaborRate.length ?
                            <SubmitButton
                                isSubmitDisabled={!canEnableSubmit(this.props.massLaborRate[0].rates)}
                                onClick={this.props::onSubmit}
                            /> : null
                        }
                    </section>
                </h2>
                <section>
                    {
                        this.props.massLaborRate.length ?
                            <LaborRateMain
                                actions={this.props.actions}
                                isDealershipModalOpen={this.props.isDealershipModalOpen}
                                laborRate={this.props.massLaborRate[0]}
                                laborRateAll={this.props.massLaborRate}
                                onDealershipModalClose={this.props::handleDealershipModalClose}
                                onDealershipModalOpen={this.props::handleDealershipModalOpen}
                                queryParamRequstID={this.props.queryParams.requestId}
                                tcsm={false}
                            /> : null
                    }
                </section>
            </section>
        );

    }

}

MassLaborRateChange.displayName = 'MassLaborRateChange';
MassLaborRateChange.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    isDealershipModalOpen: PropTypes.bool.isRequired,
    massLaborRate: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired,
    queryParams: PropTypes.object.isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(LaborRate)).isRequired
};

export default MassLaborRateChange;



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/components/index.js